import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _regeneratorRuntime from "@babel/runtime/regenerator";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Link, withRouter } from 'react-router-dom';
import Moment from 'moment';
import swal from 'sweetalert2';
import { setPageTitle } from 'actions/header';
import { getGoalsStatisticsForUsers } from 'actions/preschoolform';
import { getArchivedEducationGroups, getArchievedMentorGroups, getEducationGroups, getMentorGroups, getSection, updateArchived } from 'actions/sections';
import { getUserAssessmentDates } from "helpers/user";
import User from '_class/User';
import DateTime from '_class/DateTime';
import MentorSectionForm from 'containers/Forms/MentorSectionForm';
import SectionForm from 'containers/Forms/SectionForm';
import Modal from 'containers/Modals/Modal';
import TeacherSectionProgress from 'containers/Progress/TeacherSection';
import SectionInformation from '../Functionality/SectionInformation';
import SectionPlans from '../Functionality/SectionPlans';
import SectionPosts from '../Functionality/SectionPosts';
import SectionTools from '../Functionality/SectionTools';
import DatePickers from "containers/Progress/Partials/DatePickers";
import { Spinner } from 'UI';
import { Table, Block, Button, Tabs, Tab, translate } from '@haldor/ui';
import './_sectionStats.scss';

var PreSchoolSection = /*#__PURE__*/function (_Component) {
  _inherits(PreSchoolSection, _Component);

  var _super = _createSuper(PreSchoolSection);

  function PreSchoolSection(props) {
    var _this;

    _classCallCheck(this, PreSchoolSection);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "getStatistics", function () {
      var group = _this.props.group;
      var _this$state = _this.state,
          start = _this$state.start,
          end = _this$state.end;

      _this.props.getGoalsStatisticsForUsers(group.id, start, end);
    });

    _defineProperty(_assertThisInitialized(_this), "updateData", function () {
      _this.getStatistics();
    });

    _defineProperty(_assertThisInitialized(_this), "onDateChange", function (_ref) {
      var start = _ref.start,
          end = _ref.end;

      if (start == "Invalid date") {
        start = Moment().subtract(1, "years");
      }

      if (end == "Invalid date") {
        end = Moment().add(1, "years");
      }

      localStorage.setItem("assessment-start-date", new DateTime(start).getDateStamp());
      localStorage.setItem("assessment-end-date", new DateTime(end).getDateStamp());

      _this.setState({
        start: new DateTime(start).getDateStamp(),
        end: new DateTime(end).getDateStamp()
      });
    });

    _defineProperty(_assertThisInitialized(_this), "EditButton", function () {
      var user = new User(_this.props.currentUser);

      var isOwner = _this.props.group.owners.find(function (owner) {
        return owner.userId == _this.props.currentUser.id;
      });

      if (!user.isStudent() && isOwner != null) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
          type: "secondary",
          onClick: _this.openModal,
          disabled: _this.props.group.archived
        }, _this.props.translate('Edit')));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "ArchiveButton", function () {
      var user = new User(_this.props.currentUser);

      if (!user.isStudent()) {
        return /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Button, {
          type: "secondary",
          onClick: _this.makeArchive
        }, _this.props.translate(_this.props.group.archived ? 'Restore' : 'Archive')));
      }

      return null;
    });

    _defineProperty(_assertThisInitialized(_this), "isUserOwner", function () {
      var _this$props = _this.props,
          currentUser = _this$props.currentUser,
          group = _this$props.group;

      if (currentUser == null || group == null) {
        return false;
      }

      var foundOwner = group.owners.find(function (owner) {
        return currentUser.id == owner.id;
      });

      if (foundOwner != null) {
        return true;
      }

      return false;
    });

    _defineProperty(_assertThisInitialized(_this), "openModal", function () {
      _this.setState({
        modalIsOpen: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "makeArchive", /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var groupId, _this$props2, group, translate, result;

      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              groupId = _this.props.match.params.groupId;
              _this$props2 = _this.props, group = _this$props2.group, translate = _this$props2.translate;
              result = null;

              if (!group.archived) {
                _context.next = 9;
                break;
              }

              _context.next = 6;
              return swal.fire({
                title: translate('are-you-sure'),
                text: translate('Are you sure you want to reset this group?'),
                showCancelButton: true,
                cancelButtonText: translate('No'),
                confirmButtonText: translate('Yes')
              });

            case 6:
              result = _context.sent;
              _context.next = 12;
              break;

            case 9:
              _context.next = 11;
              return swal.fire({
                title: translate('are-you-sure'),
                html: _this.props.translate('Both the group and the Microsoft Team will be archived.<br /><br />Do you want to archive this group?'),
                showCancelButton: true,
                cancelButtonText: translate('No'),
                confirmButtonText: translate('Yes')
              });

            case 11:
              result = _context.sent;

            case 12:
              if (result != null && result.value != null) {
                _this.props.updateArchived(group).then(function () {
                  _this.setState({
                    loading: true
                  });

                  _this.props.getSection(groupId).then(function () {
                    _this.setState({
                      loading: false
                    });
                  });

                  if (group.type == 'EDUCATION_GROUP') {
                    _this.props.getEducationGroups();
                  }

                  if (group.type == 'MENTOR_GROUP') {
                    _this.props.getMentorGroups();
                  }
                });
              }

            case 13:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    })));

    _defineProperty(_assertThisInitialized(_this), "getCategories", function () {
      var categories = [];

      if (_this.props.goals != null) {
        _this.props.goals.forEach(function (goal) {
          if (!categories.find(function (category) {
            return category.title === goal.group;
          })) {
            categories.push({
              title: goal.group,
              color: goal.colorCode
            });
          }
        });
      }

      return categories;
    });

    _defineProperty(_assertThisInitialized(_this), "getGoalsByCategoryName", function (category) {
      var goals = [];

      if (_this.props.goals != null) {
        goals = _toConsumableArray(_this.props.goals).filter(function (goal) {
          return goal.group == category;
        });
      }

      return goals;
    });

    _defineProperty(_assertThisInitialized(_this), "closeModal", function (reRender, skipPrompt) {
      if (skipPrompt) {
        var groupId = _this.props.match.params.groupId;

        if (reRender) {
          _this.setState({
            loading: true
          });

          _this.props.getSection(groupId).then(function () {
            _this.setState({
              loading: false
            });
          });
        }

        _this.setState({
          modalIsOpen: false
        });
      } else {
        _this.setState({
          modalIsOpen: false
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "renderCategoryGoals", function (category) {
      var group = _this.props.group;

      var goals = _this.getGoalsByCategoryName(category);

      return /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'relative',
          margin: '-1.4rem -1.7rem'
        }
      }, /*#__PURE__*/React.createElement(Table, null, /*#__PURE__*/React.createElement("thead", null, /*#__PURE__*/React.createElement("tr", null, /*#__PURE__*/React.createElement("th", null, _this.props.translate('name')), goals.map(function (goal) {
        return /*#__PURE__*/React.createElement("th", {
          style: {
            maxWidth: 340,
            whiteSpace: 'normal',
            minWidth: 150
          },
          key: goal.id,
          title: goal.text
        }, goal.title);
      }))), /*#__PURE__*/React.createElement("tbody", null, group.students.sort(function (a, b) {
        return a.lastName.localeCompare(b.lastName);
      }).map(function (student) {
        return _this.renderStudentRow(student, goals);
      }))));
    });

    _defineProperty(_assertThisInitialized(_this), "renderStudentRow", function (student, goals) {
      var userStats = null;

      if (_this.props.goalStatistics != null) {
        userStats = _this.props.goalStatistics.find(function (statistic) {
          return statistic.studentId == student.userId;
        });
      }

      return /*#__PURE__*/React.createElement("tr", {
        key: student.userId
      }, /*#__PURE__*/React.createElement("td", null, /*#__PURE__*/React.createElement(Link, {
        to: "/user/".concat(student.userId, "/progress")
      }, student.firstName, " ", student.lastName)), goals.map(function (goal) {
        var goalStats = null;

        if (userStats != null) {
          goalStats = userStats.statistics.find(function (stat) {
            return stat.goalId == goal.id;
          });
        }

        return /*#__PURE__*/React.createElement("td", {
          style: {
            textAlign: 'center'
          },
          key: goal.id
        }, goalStats != null ? /*#__PURE__*/React.createElement("span", {
          className: "number"
        }, goalStats.total) : /*#__PURE__*/React.createElement("span", {
          className: "empty-dot"
        }));
      }));
    });

    _defineProperty(_assertThisInitialized(_this), "renderGroupContent", function () {
      var group = _this.props.group;
      var user = new User(_this.props.currentUser);
      return /*#__PURE__*/React.createElement("div", {
        className: "single-group single-task"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: _this.state.modalIsOpen,
        onClose: _this.closeModal,
        title: group.title
      }, /*#__PURE__*/React.createElement(SectionForm, {
        onAbort: _this.closeModal,
        editView: true,
        section: group
      })), /*#__PURE__*/React.createElement(SectionTools, {
        EditButton: _this.EditButton,
        ArchiveButton: _this.ArchiveButton,
        group: group
      }), /*#__PURE__*/React.createElement(SectionInformation, {
        group: group
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }), _this.props.services.news ? /*#__PURE__*/React.createElement("div", {
        id: "section-posts",
        className: "section",
        style: {
          border: 0,
          marginTop: 0
        }
      }, /*#__PURE__*/React.createElement(SectionPosts, {
        groupid: group.id,
        archived: _this.props.group.archived,
        disableCreate: !_this.isUserOwner()
      })) : null, _this.props.services.plans ? /*#__PURE__*/React.createElement("div", {
        id: "section-planning",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(SectionPlans, {
        groupid: group.id,
        archived: _this.props.group.archived,
        dateRestriction: false,
        disableCreate: !_this.isUserOwner()
      })) : null, group.students && group.students.length > 0 && !user.isStudent() ? /*#__PURE__*/React.createElement("div", {
        id: "section-pupils",
        className: "single-section form",
        style: {
          marginTop: '4rem'
        }
      }, /*#__PURE__*/React.createElement(TeacherSectionProgress, {
        groupId: group.id,
        schoolType: "PRESCHOOL"
      })) : null);
    });

    _this.state = {
      modalIsOpen: false,
      loading: false,
      end: getUserAssessmentDates().end,
      start: getUserAssessmentDates().start
    };
    return _this;
  }

  _createClass(PreSchoolSection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      var groupId = this.props.match.params.groupId;

      if (groupId != null && groupId != undefined && groupId != "") {
        this.setState({
          loading: true
        });
        this.props.getSection(groupId).then(function () {
          _this2.props.setPageTitle(_this2.props.group.title);

          _this2.setState({
            loading: false
          });

          if (_this2.props.group.type == "MENTOR_GROUP") {
            _this2.getStatistics();
          }
        });
      }
    }
  }, {
    key: "renderMentorGroup",
    value: function renderMentorGroup() {
      var _this3 = this;

      var group = this.props.group;
      var user = new User(this.props.currentUser);
      var categories = this.getCategories();
      return /*#__PURE__*/React.createElement("div", {
        className: "single-group single-task"
      }, /*#__PURE__*/React.createElement(Modal, {
        isOpen: this.state.modalIsOpen,
        onClose: this.closeModal,
        title: group.title
      }, /*#__PURE__*/React.createElement(MentorSectionForm, {
        onAbort: this.closeModal,
        editView: true,
        section: group
      })), /*#__PURE__*/React.createElement(SectionTools, {
        EditButton: this.EditButton,
        ArchiveButton: this.ArchiveButton,
        group: group
      }), /*#__PURE__*/React.createElement(SectionInformation, {
        group: group
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          clear: 'both'
        }
      }), this.props.services.news ? /*#__PURE__*/React.createElement("div", {
        id: "section-posts",
        className: "section single-section",
        style: {
          border: 0,
          marginTop: 0
        }
      }, /*#__PURE__*/React.createElement(SectionPosts, {
        groupid: group.id,
        disableCreate: !this.isUserOwner()
      })) : null, group.students && group.students.length > 0 && !user.isStudent() ? /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: '3rem'
        },
        className: "section-stats"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form"
      }, /*#__PURE__*/React.createElement("div", {
        className: "form-row"
      }, /*#__PURE__*/React.createElement(DatePickers, {
        startDate: this.state.start,
        endDate: this.state.end,
        onChange: this.onDateChange
      }))), /*#__PURE__*/React.createElement("div", {
        className: "clearfix"
      }), /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: "1rem",
          marginBottom: "1rem"
        }
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        onClick: this.updateData
      }, this.props.translate("update"))), /*#__PURE__*/React.createElement(Block, null, /*#__PURE__*/React.createElement("span", {
        className: "title"
      }, this.props.translate('goals')), categories.length > 0 ? /*#__PURE__*/React.createElement(Tabs, null, categories.map(function (category, index) {
        return /*#__PURE__*/React.createElement(Tab, {
          title: category.title,
          key: 'category' + index,
          route: 'category' + index
        }, _this3.renderCategoryGoals(category.title));
      })) : null)) : null);
    }
  }, {
    key: "render",
    value: function render() {
      var group = this.props.group;

      if (!group || this.state.loading) {
        return /*#__PURE__*/React.createElement(Spinner, {
          center: true
        });
      }

      switch (group.type) {
        case "EDUCATION_GROUP":
          return this.renderGroupContent();

        case "MENTOR_GROUP":
          return this.renderMentorGroup();

        default:
          return this.renderGroupContent();
      }
    }
  }]);

  return PreSchoolSection;
}(Component);

function mapStateToProps(state) {
  return {
    group: state.sections.activeSection,
    currentUser: state.user.currentUser,
    translate: translate(state.Languages.translations),
    services: state.Services.availableServices,
    goals: state.PreschoolGoals.preschoolGoals,
    goalStatistics: state.PreschoolGoals.statistics
  };
}

export default withRouter(connect(mapStateToProps, {
  getSection: getSection,
  updateArchived: updateArchived,
  getEducationGroups: getEducationGroups,
  getArchivedEducationGroups: getArchivedEducationGroups,
  setPageTitle: setPageTitle,
  getGoalsStatisticsForUsers: getGoalsStatisticsForUsers,
  getArchievedMentorGroups: getArchievedMentorGroups,
  getMentorGroups: getMentorGroups
})(PreSchoolSection));